const Data = [
  {
    name: "Ayush Kumar",
    position: "Media Head",
    imageUrl: "/assets/images/members/Heads25/AyushKumar.jpg",
    facebookLink: "https://www.facebook.com/share/1AF638fq7M/",
    linkedinLink: "https://www.linkedin.com/in/ayush-kumar-519a6328b/",
    email: "ayush.kumar@gyws.org"
  },
  {
    name: "Aliva Patro",
    position: "Media Head",
    imageUrl: "/assets/images/members/Heads25/AlivaPatro.jpg",
    facebookLink: "https://www.facebook.com/profile.php?id=61562000387700",
    linkedinLink: "https://www.linkedin.com/in/aliva-patro-a3a5912b3/",
    email: "aliva.patro@gyws.org"
  },
  {
    name: "Sumit Mukherjee",
    position: "Media Head",
    imageUrl: "/assets/images/members/Heads25/SumitMukherjee.jpg",
    facebookLink: "",
    linkedinLink: "",
    email: ""
  }
];

export default Data;